module.exports = __webpack_public_path__ + "static/flag-f9ceb16a587b7d1498eda032f51bbff0.svg";